export const WORK_TYPE_SETTINGS = {
  AUTOMATION: "automation-settings",
  DISPLAY: "display-settings",
  DECIMAL: "decimal-settings",
  ROUNDING: "rounding-settings",
}

export const DEFAULT_PERCENT = 10;
export const DEFAULT_FIXED_PRICE = 1000;